import { JSX } from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    BooleanInput,
    SelectInput, required
} from 'react-admin';
import { settingsSections } from "../../defaults/defaults";

export const SettingsCreate: () => JSX.Element = (): JSX.Element => {

    const choices: { id: string, name: string }[] = [];
    for (const settingsSection of settingsSections) {
        choices.push({
            id: settingsSection.path,
            name: settingsSection.sectionTitle
        })
    }

    // These ids are what the edit form switches on. 'multiple' used to be
    // written here while the edit form only handled 'multi', so any setting
    // created as Multiple Options rendered as "Unable to render Setting".
    // 'textarea' has always been editable but was never offered.
    const types: { id: string, name: string }[] = [
        { id: 'yes/no', name: 'Yes/No' },
        { id: 'text', name: 'Text' },
        { id: 'textarea', name: 'Long text' },
        { id: 'multi', name: 'Multiple Options' },
        { id: 'key/value', name: 'Key/Value' },
        { id: 'system_email_template', name: 'System Email Template' },
        { id: 'system_invoice_template', name: 'System Invoice Template' },
    ];

    return (
        <Create>
            <SimpleForm>
                <TextInput source="label"
                           label="Label"
                           helperText="How this setting is named on the settings page"
                           validate={[required()]} />
                <TextInput source="code"
                           label="Code"
                           helperText="The identifier the application reads, e.g. mailgun_api_key"
                           validate={[required()]} />
                <SelectInput source="path"
                             label="Section"
                             helperText="Which group this setting appears under"
                             validate={[required()]}
                             choices={choices} />
                <SelectInput source="type"
                             label="Type"
                             helperText="Determines the editor shown when the setting is opened"
                             validate={[required()]}
                             choices={types} />
                <BooleanInput source="is_system"
                              label="Is System"
                              defaultValue={ false }
                              validate={[required()]}
                              helperText="System settings can't be deleted once created" />
            </SimpleForm>
        </Create>
    );
}